var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClinic = function SvgClinic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.4-Sidebar-/-All",
    transform: "translate(-312.000000, -190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.Templates/01.Side-bar/Expand/Clinic",
    transform: "translate(296.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-screening",
    transform: "translate(0.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,2.99999996 C13.3280702,3.00086118 13.9991388,3.67192983 14,4.49999996 L14,4.99999996 L15.5,4.99999996 C16.6040698,5.00120557 17.4987944,5.89593024 17.5,6.99999996 L17.5,15 C17.5,16.1045695 16.6045695,17 15.5,17 L4.49999995,17 C3.39543046,17 2.49999995,16.1045695 2.49999995,15 L2.49999995,6.99999996 C2.50120555,5.89593024 3.39593022,5.00120557 4.49999995,4.99999996 L5.99999995,4.99999996 L5.99999995,4.49999996 C6.0008612,3.67192983 6.67192985,3.00086118 7.49999995,2.99999996 Z M9.99999998,7.99999999 C9.72385762,7.99999999 9.49999998,8.22385761 9.49999998,8.49999999 L9.49999998,10.5 L7.49999998,10.5 C7.22385761,10.5 6.99999998,10.7238576 6.99999998,11 C6.99999998,11.2761424 7.22385761,11.5 7.49999998,11.5 L9.49999998,11.5 L9.49999998,13.5 C9.49999998,13.7761424 9.72385762,14 9.99999998,14 C10.2761424,14 10.5,13.7761424 10.5,13.5 L10.5,11.5 L12.5,11.5 C12.7761424,11.5 13,11.2761424 13,11 C13,10.7238576 12.7761424,10.5 12.5,10.5 L10.5,10.5 L10.5,8.49999999 C10.5,8.22385761 10.2761424,7.99999999 9.99999998,7.99999999 Z M12.5,3.99999996 L7.49999998,3.99999996 C7.22385761,3.99999996 6.99999998,4.22385759 6.99999998,4.49999996 L6.99999998,4.99999996 L13,4.99999996 L13,4.49999996 C13,4.22385759 12.7761424,3.99999996 12.5,3.99999996 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClinic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clinic.f8aaa4ec.svg";
export { ForwardRef as ReactComponent };